import React, { Suspense, useEffect } from "react";
import SideNav from "containers/SideNav";
import { useDispatch } from "react-redux";
import { Await, defer, Outlet, useLoaderData, useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import { fetchTagsSuccess, resetTags } from "store/actions/tagsList";

import { fetchTagsApi } from "api/tagsList";

import { updateSystemId } from "utils/utils";

import PageLoading from "components/PageLoading";

const useStyles = makeStyles(() => ({ mainContent: { paddingLeft: "79px", width: "100%", overflow: "hidden" } }));

const MainPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { systemId } = useParams();
  const loaderData = useLoaderData();

  useEffect(
    () => () => {
      dispatch(resetTags());
      updateSystemId();
    },
    []
  );

  const onTagsLoad = loadedData => {
    dispatch(fetchTagsSuccess(loadedData?.data?.Tags || []));
    return <Outlet />;
  };

  return (
    <>
      <SideNav systemId={systemId} />
      <div className={classes.mainContent}>
        <Suspense fallback={<PageLoading />}>
          <Await resolve={loaderData.tags}>{loadedTags => onTagsLoad(loadedTags)}</Await>
        </Suspense>
      </div>
    </>
  );
};

export default MainPage;

export async function tagsLoader({ params }) {
  updateSystemId(params.systemId);
  return defer({ tags: fetchTagsApi() });
}
